import React from 'react';
import { Link } from 'react-router-dom'; 
import API from '../../servicios/api';

class ListarEmpleados extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            datosCargados:false,
            empleados:[]
         }
    }

    editarDatos = (id) => {
        console.log(id);
        fetch(API + "?consultar="+id)
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            console.log(datos);
        })
        .catch(console.log)
    }
    borrarDatos = (id) => {
        fetch(API + "?borrar="+id)
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            this.cargarDatos();
        })
        .catch(console.log)
    }

    cargarDatos() {
        // fetch("http://jsonplaceholder.typicode.com/users")
        fetch(API + "")
        .then(respuesta => respuesta.json())
        .then((datos)=>{
            // console.log(datos);
            if (datos.length>0 && datos[0].id){
                this.setState({ 
                    datosCargados:true,
                    empleados: datos
                });
            } else {
                this.setState({ 
                    datosCargados:true,
                    empleados: []
                });
            }
            
        })
        .catch(console.log)
    }

    componentDidMount(){
        this.cargarDatos();
    }

    render() { 
        const { datosCargados, empleados} = this.state;
        if (!datosCargados) {
            return(<div><div className="spinner-border text-success"></div>Cargando datos...</div>);
        } else {
            if (datosCargados && empleados.length===0){
                return (<div>No hay registros</div>);
            } else {
                return ( 
                <div className="card">
                    <div className="card-header">
                        <Link to={"/nuevoempleado"} className="btn btn-success">Agregar nuevo empleado</Link>
                    </div>
                    <div className="card-body">
                        <h4 className="card-title">Lista de Empleados</h4>
                        <div className="table-responsive-sm">
                            <table className="table table-sm table-hover table-success table-striped table-empleados">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Nombre</th>
                                        <th>Celular</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        empleados.map(
                                            (empleado) => (
                                                <tr key={empleado.id}>
                                                    <td>{empleado.id}</td><td>{empleado.nombres}</td>
                                                    <td>{empleado.celular}</td>
                                                    {/* <td>{empleado.email}</td> */}
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            <Link to={"/perfileditar/" + empleado.claveAPI} className="btn btn-warning btn-sm">Editar</Link>
                                                            <button type="button" onClick={() => this.borrarDatos(empleado.id)} className="btn btn-danger btn-sm">Borrar</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        )

                                    }

                                </tbody>
                            </table>
                        </div>

                    </div>
                    <div className="card-footer text-muted">

                    </div>
                </div>
                );
            }
        }
    }
}
 
export default ListarEmpleados; 